module.exports = __webpack_public_path__ + "img/ide-action.1c095501.svg";